<template>
  <div class="impacted-installments-list">
    <h6 class="mb-4">Parcelas impactadas</h6>

    <div class="table-responsive">
      <table class="impacted-installments-list__table">
        <thead>
          <tr>
            <th>Parcela</th>
            <th>Vencimento</th>
            <th>Valor anterior</th>
            <th>Novo valor ou status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="`${item.type}-${item.id}`">
            <td>{{ item.installmentLabel }}</td>
            <td>{{ item.dueDate }}</td>
            <td>{{ formatCurrencyBRL(item.previousValue) }}</td>
            <td>
              <span v-if="item.type === 'changed'">
                {{ formatCurrencyBRL(item.newValue) }}
              </span>
              <vs-chip v-else :color="item.statusColor">{{ item.status }}</vs-chip>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { formatCurrencyBRL } from '../utils/refundCompensation';

export default {
  name: 'ImpactedInstallmentsList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatCurrencyBRL,
  },
};
</script>

<style lang="scss" scoped>
.impacted-installments-list__table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 14px 12px;
    border-bottom: 1px solid #e5e7eb;
    text-align: left;
    vertical-align: middle;
  }

  th {
    color: #6b7280;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  td {
    color: #111827;
  }
}
</style>
